/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import StatusMessage from '../../../../common/components/core/StatusMessage';
import AccessButton from '../../../../common/components/AccessControl/AccessButton';
import { CHANNEL_LEVEL_SETTINGS, WRITE_PERMISSION } from '../../../../common/support/accessControlConstants';
import { convertToCalendarTimezone } from '../../../support/dateUtils';
export const INVALID_TOKEN_STATUS = 'invalid_token';
export const PENDING_REQUEST_STATUS = 'pending_request';
export const SUCCESS_STATUS = 'success';
export const PARTNER_ERROR_STATUS = 'partner_error';
export const DATA_UNAVAILABLE_STATUS = 'data_unavailable';
export const STATUS_UNAVAILABLE = 'status_unavailable';
export function InvalidTokenLabel(): React.ReactElement<typeof StatusMessage> {
  return (
    <StatusMessage
      type="error"
      text="Issues: Action Required"
      className="ad-account__status-label ad-account__invalid-token"
    />
  );
}
export function PendingRequestLabel(): React.ReactElement<typeof StatusMessage> {
  return (
    <StatusMessage
      type="pending"
      text="Data Pending: See Details"
      className="ad-account__status-label ad-account__pending-request"
    />
  );
}
export function AccountWorkingLabel(): React.ReactElement<typeof StatusMessage> {
  return (
    <StatusMessage
      type="success"
      text="Working"
      overrideIconColorClass="h_c-success-bluish"
      className="ad-account__status-label ad-account__working"
    />
  );
}
export function PartnerErrorLabel(): React.ReactElement<typeof StatusMessage> {
  return <StatusMessage type="warning" text="Minor Issues" className="ad-account__status-label ad-account__partner-error" />;
}
export function DataUnavailableLabel(): React.ReactElement<typeof StatusMessage> {
  return (
    <StatusMessage
      type="pending"
      text="No Data is Available"
      className="ad-account__status-label ad-account__data-unavailable"
    />
  );
}
export function StatusUnavailableLabel(): null {
  return null;
}
type Props = {
  machineName: string;
  openReauthModal?: () => void;
  adPartnerName?: string;
  lastSuccessTimestamp: number | null;
};
export class InvalidTokenSuggestion extends React.PureComponent<Props> {
  render() {
    const { machineName } = this.props;
    return (
      <StatusMessage
        type="error"
        text={
          <div>
            <div className="ad-account__suggestion-header">Stopped: token invalid</div>
            <div className="ad-account__suggestion-body">
              {'The authentication token for this account is invalid. Please reauthenticate to refresh the token.'}
            </div>
            <AccessButton
              accessResources={[CHANNEL_LEVEL_SETTINGS]}
              permission={WRITE_PERMISSION}
              onClick={this.props.openReauthModal}
              className="button-size-small ad-account__reauthentication-button"
              i13nModel={{
                label: 'Open Reauthenticate Modal',
              }}
              testid={`${machineName}-facebook-reauth-modal-button`}
            >
              Reauthenticate
            </AccessButton>
          </div>
        }
        className="ad-account__status-suggestion"
      />
    );
  }
}
export class PendingRequestSuggestion extends React.PureComponent<Props> {
  render() {
    return (
      <StatusMessage
        type="pending"
        text={
          <div>
            <div className="ad-account__suggestion-header">Data not yet requested</div>
            <div className="ad-account__suggestion-body">
              {
                'No data has been requested for this account recently - probably because the integration was just enabled or reset. Please check back in a few hours.'
              }
            </div>
          </div>
        }
        className="ad-account__status-suggestion"
      />
    );
  }
}
export class AccountWorkingSuggestion extends React.PureComponent<Props> {
  render() {
    const _getLastSuccessTimestampOrEmpty = () => {
      const { lastSuccessTimestamp } = this.props;

      try {
        return convertToCalendarTimezone(new Date(lastSuccessTimestamp).toISOString(), {
          sameDay: '[Today] [at] h:mmA z',
          lastDay: '[Yesterday] [at] h:mmA z',
          sameElse: 'MMM Do [at] h:mmA z',
          // It appears that all calendar options need to be explicitly states
          lastWeek: 'MMM Do [at] h:mmA z',
        });
      } catch (e) {
        return '';
      }
    };

    return (
      <StatusMessage
        type="success"
        overrideIconColorClass="h_c-success-bluish"
        text={
          <div>
            <div className="ad-account__suggestion-header">Working</div>
            <div className="ad-account__suggestion-body">{`Data last updated: ${_getLastSuccessTimestampOrEmpty()}`}</div>
          </div>
        }
        className="ad-account__status-suggestion"
      />
    );
  }
}
export class PartnerErrorSuggestion extends React.PureComponent<Props> {
  render() {
    const { adPartnerName } = this.props;
    return (
      <StatusMessage
        type="warning"
        text={
          <div>
            <div className="ad-account__suggestion-header">Stopped: ad partner error</div>
            <div className="ad-account__suggestion-body">
              {`The ${
                adPartnerName ? adPartnerName : 'ad network'
              } API is experiencing errors. Data may be temporarily delayed. Please check back in a few hours.`}
            </div>
          </div>
        }
        className="ad-account__status-suggestion"
      />
    );
  }
}
export class DataUnavailableSuggestion extends React.PureComponent<Props> {
  render() {
    return (
      <StatusMessage
        type="pending"
        text={
          <div>
            <div className="ad-account__suggestion-header">No data is available</div>
            <div className="ad-account__suggestion-body">
              {
                'Data was requested for this account, but no data was available in the last 7 days. Please run campaigns to see data.'
              }
            </div>
          </div>
        }
        className="ad-account__status-suggestion"
      />
    );
  }
}
export function StatusUnavailableSuggestion(): null {
  return null;
}
const AccountStatusComponents = {
  [INVALID_TOKEN_STATUS]: {
    Label: InvalidTokenLabel,
    Suggestion: InvalidTokenSuggestion,
  },
  [PENDING_REQUEST_STATUS]: {
    Label: PendingRequestLabel,
    Suggestion: PendingRequestSuggestion,
  },
  [SUCCESS_STATUS]: {
    Label: AccountWorkingLabel,
    Suggestion: AccountWorkingSuggestion,
  },
  [PARTNER_ERROR_STATUS]: {
    Label: PartnerErrorLabel,
    Suggestion: PartnerErrorSuggestion,
  },
  [DATA_UNAVAILABLE_STATUS]: {
    Label: DataUnavailableLabel,
    Suggestion: DataUnavailableSuggestion,
  },
  [STATUS_UNAVAILABLE]: {
    Label: StatusUnavailableLabel,
    Suggestion: StatusUnavailableSuggestion,
  },
};
export default AccountStatusComponents;
